export const sanitizeChannelSplitterOptions = (options) => {
    return { ...options, channelCount: options.numberOfOutputs };
};
//# sourceMappingURL=sanitize-channel-splitter-options.js.map